export const PAYMENT_TABS = {
  CARD: "card",
  LINK: "link",
  CASH: "cash",
  OTHERS: "others"
}

export const LINK_PROVIDERS = {
  STRIPE: "stripe",
  PAYPAL: "paypal"
}

export const OTHERS_TYPES = [
  { value: "check", label: "Check" },
  { value: "e_transfer", label: "E-Transfer" },
  { value: "paypal", label: "Paypal" },
  { value: "zelle", label: "Zelle" },
  { value: "venmo", label: "Venmo" },
  { value: "other", label: "Other" }
]

export const paymentProvider = {
  card: "stripe",
  link: "stripe",
  paypalLink: "paypal"
}
